/**
 * Legacy workspace registry.
 *
 * DASHBOARD_CAROUSEL_ENTRIES still feeds widget-order resolution and the
 * press-and-hold Dashboard Navigator. It is not the mobile swipe ring.
 *
 * Mobile Home swipe is two faces only: `kpi_dashboard` and `quick_create`.
 * Either horizontal direction moves between them (`getAdjacentDashboardScreen`).
 * Passive summary screens stay in this registry so saved widget order and the
 * navigator do not lose their ids, but swipe no longer opens them.
 */

export const DASHBOARD_CAROUSEL_ENTRIES = [
  {
    id: "kpi_dashboard",
    label: "KPI Dashboard",
    preview: {
      theme: "kpi",
      metrics: [
        { label: "Today's Hours", value: "—" },
        { label: "Active Projects", value: "—" },
        { label: "Crew Status", value: "—" },
      ],
    },
  },
  {
    id: "accounts_receivable",
    label: "Accounts Receivable",
    preview: {
      theme: "payable",
      metrics: [
        { label: "Outstanding", value: "—" },
        { label: "Paid This Month", value: "—" },
      ],
    },
  },
  {
    id: "accounts_payable",
    label: "Accounts Payable",
    preview: {
      theme: "payable",
      metrics: [
        { label: "Unpaid Entries", value: "—" },
        { label: "Payroll Queue", value: "—" },
      ],
    },
  },
  {
    id: "financial_position",
    label: "Financial Position",
    preview: {
      theme: "kpi",
      metrics: [
        { label: "Current Cash", value: "—" },
        { label: "Available Cash", value: "—" },
        { label: "Reserved Cash", value: "—" },
      ],
    },
  },
  {
    id: "estimate_pipeline",
    label: "Estimate Pipeline",
    preview: {
      theme: "kpi",
      metrics: [
        {
          label: "Active",
          value: "—",
          dynamicKey: "CP_PREVIEW_ESTIMATE_PIPELINE_ACTIVE",
        },
      ],
    },
  },
  {
    id: "create_client",
    label: "Clients",
    preview: {
      theme: "kpi",
      metrics: [
        { label: "Active Clients", value: "—" },
        { label: "Recent Activity", value: "—" },
      ],
    },
  },
  {
    id: "create_project",
    label: "Projects",
    preview: {
      theme: "kpi",
      metrics: [
        { label: "Active Projects", value: "—" },
        { label: "On Site Today", value: "—" },
      ],
    },
  },
];

export const DASHBOARD_CAROUSEL_ORDER = DASHBOARD_CAROUSEL_ENTRIES.map(
  (entry) => entry.id,
);

export const SWIPE_THRESHOLD_PX = 80;
export const DIRECTION_LOCK_PX = 10;

export function isDashboardCarouselScreen(screen) {
  return screen === "quick_create" || DASHBOARD_CAROUSEL_ORDER.includes(screen);
}

/**
 * @param {string} screen
 * @returns {{ index: number, total: number, label: string } | null}
 */
export function getDashboardCarouselPosition(screen) {
  const index = DASHBOARD_CAROUSEL_ORDER.indexOf(screen);
  if (index === -1) {
    return null;
  }

  return {
    index: index + 1,
    total: DASHBOARD_CAROUSEL_ORDER.length,
    label: DASHBOARD_CAROUSEL_ENTRIES[index].label,
  };
}

/**
 * Home and Quick Create are the two faces of the main mobile workspace.
 * Direction does not choose a different destination.
 *
 * @param {string} current - Active screen id
 * @param {"left" | "right"} direction
 * @returns {string | null}
 */
export function getAdjacentDashboardScreen(current, direction) {
  if (direction !== "left" && direction !== "right") {
    return null;
  }

  if (current === "kpi_dashboard") {
    return "quick_create";
  }

  if (current === "quick_create") {
    return "kpi_dashboard";
  }

  return null;
}
